import { Injectable } from '@angular/core';
import { PaymentIQData } from 'src/app/shared/interfaces/deposit.interface';
import {
  MatConnectedDialog,
  MatConnectedDialogMobileAnimation,
  MatConnectedDialogRef,
} from 'src/app/shared/service/connected-dialog';
import { CardDepositComponent } from './card-deposit.component';

@Injectable({ providedIn: 'root' })
export class CardDepositService {
  constructor(public matConnectedDialog: MatConnectedDialog) {}
  private dialogRef?: MatConnectedDialogRef<CardDepositComponent>;

  /**
   * 打開充值彈窗
   * @param curData
   */
  openCardModal(curData: PaymentIQData): void {
    if (!this.dialogRef) {
      this.dialogRef = this.matConnectedDialog.open(CardDepositComponent, {
        data: curData,
        mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
        mobileFixedBottom: true,
        closeOnNavigation: false,
      });

      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = undefined;
      });
    }
  }

  /**
   * 關閉彈窗
   */
  closeCardModal(): void {
    this.dialogRef?.close();
    this.dialogRef = undefined;
  }
}
